module.exports = __webpack_public_path__ + "img/Gloria Arthur, Co-Director of Events, Schulich Finance Association.20954e9c.webp";